<template>
  <div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  name: "LoginLayout",
}
</script>

<style scoped>

</style>